import axios from 'axios';

const url =
	process.env.NODE_ENV === 'development'
		? 'http://localhost:6005'
		: 'https://manna-ra-api-r6jar.ondigitalocean.app';

export const api = axios.create({
	baseURL: url,
});
